var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { from, merge, of, Subject } from 'rxjs';
import { catchError, map, first, switchMap, tap, share } from 'rxjs/operators';
export var initialRequestState = {
    data: null,
    loading: false,
    loaded: false,
    error: null,
    variables: null
};
var RequestStore = /** @class */ (function () {
    function RequestStore(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.initialData, initialData = _c === void 0 ? null : _c, _d = _b.skipQuery, skipQuery = _d === void 0 ? function (x) { return undefined; } : _d, _e = _b.ssrId, ssrId = _e === void 0 ? null : _e, _f = _b.updateData, updateData = _f === void 0 ? function (data) { return data; } : _f;
        this.variables$ = new Subject();
        this.loadedValueFromContext = false;
        this.mapRequestResult = function (variables, options) { return function (data) { return ({
            data: _this.updateData(data, _this.state.data, {
                store: _this,
                variables: variables,
                options: options
            }),
            loading: false,
            loaded: true,
            error: null,
            variables: variables
        }); }; };
        this.handleError = function (error) {
            console.error(error);
            return { error: error, loading: false };
        };
        this.initialState = __assign({}, initialRequestState, { data: initialData });
        this.state = this.initialState;
        this.ssrId = ssrId;
        this.skipQuery = skipQuery;
        this.updateData = updateData;
        this.state$ = this.createState();
    }
    Object.defineProperty(RequestStore.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (newValue) {
            this._state = newValue;
        },
        enumerable: true,
        configurable: true
    });
    RequestStore.prototype.createState = function () {
        var _this = this;
        return this.variables$.pipe(switchMap(function (_a) {
            var variables = _a.variables, options = _a.options;
            var state = __assign({ loading: true, variables: variables, error: null }, options.changeState);
            return merge(of(state), from(_this.performSkippableRequest(variables, options)).pipe(map(_this.mapRequestResult(variables, options)), catchError(function (error) { return of(_this.handleError(error)); })));
        }), map(function (change) { return (__assign({}, _this.state, change)); }), tap(function (state) { return (_this.state = state); }), share());
    };
    RequestStore.prototype.performSkippableRequest = function (variables, options) {
        var skipped = this.skipQuery(variables);
        if (skipped !== undefined) {
            return of(skipped);
        }
        return this.performRequest(variables, options);
    };
    RequestStore.prototype.performRequest = function (variables, options) {
        throw new Error('Please override performRequest function in your RequestStore extension');
    };
    RequestStore.prototype.loadData = function (variables, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.state$
                            .pipe(first(function (state) {
                            return !state.loading &&
                                (state.loaded || state.error) &&
                                state.variables === variables;
                        }))
                            .toPromise();
                        this.variables$.next({ variables: variables, options: options });
                        return [4 /*yield*/, promise];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RequestStore.prototype.getValueFromContext = function (context) {
        if (this.ssrId && context && !this.loadedValueFromContext) {
            this.loadedValueFromContext = true;
            var state = context.getState(this.ssrId);
            if (state) {
                this.state = state;
            }
        }
        return this.state;
    };
    RequestStore.prototype.setContextValue = function (context) {
        if (this.ssrId && context) {
            context.setState(this.ssrId, this.state);
        }
    };
    RequestStore.prototype.reset = function (state) {
        this.state = __assign({}, initialRequestState, state);
    };
    return RequestStore;
}());
export { RequestStore };
//# sourceMappingURL=RequestStore.js.map